"use client";
import React, { useState } from "react";
import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";
import { testimonials } from "@/lib/data";

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const t = testimonials?.[active];

  return (
    <section className="py-16 bg-muted">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-section-title text-foreground">
            İşletme Sahipleri Ne Diyor?
          </h2>
        </div>

        <div className="relative bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-border text-center">
          {/* Stars */}
          <div className="flex justify-center gap-1 mb-6">
            {[1, 2, 3, 4, 5]?.map((s) => (
              <Icon key={s} name="StarIcon" size={20} variant="solid" className="text-accent" />
            ))}
          </div>

          {/* Quote */}
          <blockquote className="text-lg md:text-xl font-medium text-foreground leading-relaxed mb-8 max-w-2xl mx-auto italic">
            &ldquo;{t?.text}&rdquo;
          </blockquote>

          {/* Author */}
          <div className="flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-2xl overflow-hidden ring-4 ring-primary/20">
              <AppImage
                src={t?.avatar}
                alt={`${t?.name}, ${t?.business} sahibi — MyKonya referansı`}
                width={64}
                height={64}
                className="object-cover w-full h-full"
              />
            </div>
            <div>
              <p className="font-bold text-foreground">{t?.name}</p>
              <p className="text-sm text-muted-foreground">{t?.role}, {t?.business}</p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials?.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                aria-label={`Referans ${i + 1}`}
                className={`rounded-full transition-all duration-300 ${
                  i === active ? "w-8 h-2.5 bg-primary" : "w-2.5 h-2.5 bg-border"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}